import { Stack } from '@mui/material';
import { useAtom, useAtomValue } from 'jotai';

import { PopupFilter } from '../../../components/PopupFilter';
import { SelectItem } from '../../../types';
import { fundOptionsStateJ } from '../../PortfolioOverview/state/FundFilterStateJ';
import { securitiesFundFilterState, securitiesRealizedFilterState } from './AllSecuritiesUIStateJ';

const realizedOptions: SelectItem[] = [
  { value: 'Realized', id: 'realized' },
  { value: 'Unrealized', id: 'unrealized' },
];
export function AllSecuritiesFilters() {
  const [realizedFilter, setRealizedFilter] = useAtom(securitiesRealizedFilterState);
  const [fundFilter, setFundFilter] = useAtom(securitiesFundFilterState);
  const fundOptions = useAtomValue(fundOptionsStateJ);

  return (
    <Stack direction={'row'} gap='1rem'>
      <PopupFilter
        selected={fundFilter}
        setSelected={setFundFilter}
        options={fundOptions}
        labels={{ item: 'Fund' }}
        groupable
      />
      <PopupFilter
        selected={realizedFilter}
        setSelected={setRealizedFilter}
        options={realizedOptions}
        labels={{ item: 'Realized/Unrealized', all: 'Realized/Unrealized' }}
        searchable={false}
      />
    </Stack>
  );
}
